:host {
    display: flex;
    max-width: 100%;
}

.joy-tags-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    gap: var(--joy-core-spacing-4);

    &--center {
        justify-content: center;
    }

    &--left {
        justify-content: flex-start;
    }


    &--right {
        justify-content: flex-end;
    }
}